import { render, staticRenderFns } from "./TextTOC.vue?vue&type=template&id=647050ac"
import script from "./TextTOC.vue?vue&type=script&lang=js"
export * from "./TextTOC.vue?vue&type=script&lang=js"
import style0 from "./TextTOC.vue?vue&type=style&index=0&id=647050ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports